import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

interface CssProps {
  bannerImage: string;
  bannerColor: string;
  textColor: string;
}

export const BannerStyles = makeStyles<CssProps>()((theme: Theme, props) => ({
  container: {
    color: props.textColor,
    wordBreak: 'break-word',
    backgroundSize: 'cover',
    overflow: 'hidden',
    display: 'flex',
    padding: '3.75rem 1.875rem',
    [theme.breakpoints.up('sm')]: {
      padding: '2.5rem',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '5rem',
    },
  },
  projectDateSection: {
    marginTop: '1.25rem',
    fontWeight: 700,
    fontSize: '1.75rem',
    lineHeight: 'normal',
    [theme.breakpoints.up('sm')]: {
      marginTop: '2rem',
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: '2rem',
      fontSize: '2.5rem',
      lineHeight: '3.404rem',
    },
  },
  eventStartSection: {
    marginTop: '0.313rem',
    fontSize: '1rem',
    fontWeight: 400,
    [theme.breakpoints.up('sm')]: {
      marginTop: '0.626rem',
      fontSize: '1.125rem',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '1.25rem',
    },
  },
  registerationCloseSection: {
    fontWeight: 700,
    marginTop: '0.313rem',
    fontSize: '1.125rem',
    lineHeight: 'normal',
    [theme.breakpoints.up('sm')]: {
      marginTop: '0.626rem',
      fontSize: '1.25rem',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '1.5rem',
      marginTop: '1.5rem',
      lineHeight: '2.043rem',
    },
  },
  backgroundImage: {
    background: `url('${props.bannerImage}') no-repeat`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  bgColorContainer: {
    backgroundColor: props.bannerColor,
  },
  contentSection: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('lg')]: {
      paddingRight: '40px',
    },
  },
  mediaContainer: {
    maxHeight: '450px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
      maxHeight: '450px',
      maxWidth: '100%',
      objectFit: 'contain',
    },
    marginTop: '1.875rem',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: '40px',
      marginTop: '0',
    },
  },
  subHeading: {
    marginTop: '1.25rem',
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: '1.5rem',
    [theme.breakpoints.up('sm')]: {
      marginTop: '1.25rem',
      fontSize: '1.25rem',
      fontWeight: 400,
      lineHeight: '1.875rem',
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: '0.75rem',
    },
  },
  bannerCTA: {
    width: '100%',
    padding: '12px 24px',
    fontSize: '16px',
    [theme.breakpoints.up('sm')]: {
      width: 'auto',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '18px',
      width: 'auto',
    },
  },
  buttonProgress: {
    color: 'inherit',
    margin: '0px 0px 0px 5px',
  },
  eventHeading: {
    fontSize: '36px',
    fontWeight: 'bold',
    wordBreak: 'break-word',
    lineHeight: 'normal',
    marginBottom: '0.75rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '45px',
      marginBottom: '0.625rem',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '55px',
      marginBottom: '0.625rem',
    },
  },
}));
